// Generated by ts-to-zod
import { z } from 'zod';

export const authInfoSchema = z.object({
  key: z.string(),
  domain: z.string(),
});
